// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__l1G5F","point":"Summary_point__9d+Xk","score":"Summary_score__cBZ29","badge":"Summary_badge__OEV05"};